/**
 * 获取全部小写的 ua
 * @returns {string}
 */
let getUa = function getUa() {
  let ua = (navigator && navigator.userAgent) || '';
  return ua.toLowerCase();
};
/**
 * 判断是否在微信浏览器环境
 * @returns {boolean}
 */
export const isWeChat = () => {
  let ua = getUa();
  return ua.includes('micromessenger') && !ua.includes('miniprogram');
};

export const isDev = process.env.NODE_ENV !== 'development';

const getMobileDetect = (userAgent: NavigatorID['userAgent']) => {
  const isAndroid = () => (userAgent ? Boolean(userAgent.match(/Android/i)) : false);
  const isIos = () => (userAgent ? Boolean(userAgent.match(/iPhone|iPad|iPod/i)) : false);
  const isOpera = () => (userAgent ? Boolean(userAgent.match(/Opera Mini/i)) : false);
  const isWindows = () => (userAgent ? Boolean(userAgent.match(/IEMobile/i)) : false);
  const isMobile = () => Boolean(isAndroid() || isIos() || isOpera() || isWindows());
  const isDesktop = () => Boolean(!isMobile());
  return {
    isMobile,
    isDesktop,
    isAndroid,
    isIos,
  };
};
export default getMobileDetect;

// 是否是日常环境
export const isDaily = () => {
  console.log('log_[process.env.ICE_EXE_ENV]==>', process.env.ICE_EXE_ENV);
  return process.env.ICE_EXE_ENV === 'daily';
};
